import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import Action from '../Action';
import { EnvironmentSelect } from '../EnvironmentSelect';

import { NavTab } from '~/components/NavTab';
import Role from '~/components/Role';

interface SubHeaderLinkConfig {
  roles?: string[];
  'data-testid'?: string;
  routeName: string;
  path: string;
  name: string;
  isBeta?: boolean;
  isHidden?: boolean;
}

interface SubHeaderProps {
  realm: string;
  configActionButton: any[];
  configActionButtonRoles: string[];
  hiddenPages: string[];
  environmentSelectRouteWhiteList?: string[];
  links?: SubHeaderLinkConfig[];
}

const SubHeader: FC<SubHeaderProps> = ({
  realm,
  configActionButton,
  configActionButtonRoles,
  hiddenPages,
  links = [],
  environmentSelectRouteWhiteList = []
}) => {
  const location = useLocation();

  const isRunView = location.pathname.includes(`${realm}/operation/run`);

  const visibleLinks = links.filter(
    link => !link.isHidden && !hiddenPages.includes(link.routeName)
  );

  const activeRoute = visibleLinks.find(link =>
    location.pathname.includes(`/${realm}/${link.path}`)
  )?.routeName;
  const showEnvironmentSelect = Boolean(
    activeRoute && environmentSelectRouteWhiteList.includes(activeRoute)
  );

  return (
    <div className='relative bg-surface'>
      {visibleLinks.length > 0 ? (
        <div className='flex items-start gap-4 px-7'>
          {showEnvironmentSelect ? (
            <div className='flex h-12 flex-col justify-end'>
              <EnvironmentSelect />
            </div>
          ) : null}
          <div className='flex min-w-0 flex-1 items-center border-b border-solid border-outline-hover pt-2'>
            {visibleLinks.map(link => {
              const tab = (
                <NavTab
                  key={link.routeName}
                  to={`/${realm}/${link.path}`}
                  name={link.name}
                  isBeta={link.isBeta}
                  data-testid={link['data-testid']}
                />
              );

              if (link.roles && link.roles.length > 0) {
                return (
                  <Role
                    key={link.routeName}
                    environmentCapable
                    name={link.roles}
                  >
                    {tab}
                  </Role>
                );
              }
              return tab;
            })}
          </div>
        </div>
      ) : null}
      {!isRunView ? (
        <div
          className='absolute -bottom-[18px] right-6 z-[49]'
          data-testid='build-create-button'
        >
          <Role name={configActionButtonRoles}>
            <Action configActionButton={configActionButton} />
          </Role>
        </div>
      ) : null}
    </div>
  );
};

export default SubHeader;
